import React from 'react';
import Route from './components/Route';
//import Trick from './Trick';




function App() {
    return(
      <div>
         <Route/>
      </div>
    )
 
}

export default App;
